export default process.env.REACT_APP_COUNTRY_FLAG_URL_PREFIX || "https://cdn.tryotel.com/country-flag/"